export default {
    setAccountShareHoldings: ({
        commit, rootGetters
    }, customer = {}) => {
        return axios
            .get(`/api/customers/${rootGetters.activeAccount.external_client_id}/balance`, {
            params: {
                    type: 'account-share-balance',
                    currency: 'GHS',
                    account_code: customer?.account_code,
                    user_id: customer?.user_id,
                },
            })
            .then(({
                data: {
                    data: {
                        account_share_balance
                    }
                }
            }) => commit('setAccountShareHoldings', account_share_balance))
    },
    setCashBalance: ({
        commit, rootGetters
    }, customer = {}) => {
        return axios
            .get(`/api/customers/${rootGetters.activeAccount.external_client_id}/balance`, {
                params: {
                    type: 'cash-balance',
                    currency: 'GHS',
                    account_code: customer?.account_code,
                },
            })
			.then(({ data: { data: { cash_balance } } }) => commit('setCashBalance', cash_balance))
	},
	getTradingHours: ({ commit }) => {
		return axios
			.get('/api/app-configurations/MARKET_HOURS')
			.then(({ data: { data } }) => {
                commit('setTradingHours', data.app_configuration)
                return data.app_configuration
            })
			.catch(({ response }) => console.log(response))
	},
}
